/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type MessageStatus = 'Undefined' | 'Read' | 'Unread' | 'Deleted';

export const MessageStatus = {
    Undefined: 'Undefined' as MessageStatus,
    Read: 'Read' as MessageStatus,
    Unread: 'Unread' as MessageStatus,
    Deleted: 'Deleted' as MessageStatus
};